import StartCard from './pages/start-game'

const GameApp = () => {
  return <StartCard />
}

export default GameApp
